import StepClose from '../handlers/step_close'
import CloseJob from '../handlers/close_job'

const handlers = {
  StepClose,
  CloseJob
}

document.addEventListener("turbolinks:load", () => {
  document.querySelectorAll("[data-handler]").forEach((element) => {
    let handlerName = element.getAttribute('data-handler')
    
    handlers[handlerName].run(element)
  })
})